import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { branchIfPassesPredicate } from 'ad-hok-utils'
import { createUseStyles } from 'react-jss'
import { addApi } from 'shared/src/api'
import { addNavigate } from 'shared/src/utils/addNavigate'
import { getEnvVar } from 'shared/src/utils/env'
import {
  addDataLoadingFromPromise,
  isLoading,
  isError,
} from 'shared/src/utils/dataLoading'
import { CSSProperties, FC } from 'react'

import appleIcon from '../../assets/apple-logo.svg'
import googleIcon from '../../assets/google-logo.svg'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    gap: 10,
    flexDirection: 'column',
  },
  button: {
    width: '100%',
    height: 60,
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    gap: 20,
    fontSize: 19,
    backgroundColor: 'white',
    color: 'black',
    fontWeight: 'normal',
  },
})

type Props = {
  stateParams?: string
  style?: CSSProperties
}
export const OmniAuth: FC<Props> = flowMax(
  addDisplayName('OmniAuth'),
  addNavigate,
  addApi,
  addProps((Props) => ({
    classes: useStyles(),
    apiRoot: getEnvVar('API_ROOT'),
    stateParams: Props.stateParams ? `?${Props.stateParams}` : '',
    style: Props.style,
  })),
  addDataLoadingFromPromise(
    'csrfTokenData',
    ({ api }) => api.auth.omni_csrf(),
    [],
    () => `csrf-${Date.now()}`
  ),
  branchIfPassesPredicate('csrfTokenData', isLoading),
  branchIfPassesPredicate('csrfTokenData', isError),
  addProps(({ csrfTokenData }) => ({
    csrf_token: csrfTokenData.data.token,
  })),
  ({ classes, csrf_token, apiRoot, stateParams, style }) =>
    csrf_token ? (
      <div className={classes.container} style={style}>
        <form action={`${apiRoot}/auth/apple${stateParams}`} method="POST">
          <input type="hidden" name="authenticity_token" value={csrf_token} />
          <button type="submit" className={classes.button}>
            <img src={appleIcon} alt="" />
            Sign in with Apple
          </button>
        </form>
        <form
          action={`${apiRoot}/auth/google_oauth2${stateParams}`}
          method="POST"
        >
          <input type="hidden" name="authenticity_token" value={csrf_token} />
          <button type="submit" className={classes.button}>
            <img src={googleIcon} style={{ height: 20 }} alt="" />
            <span>Sign in with Google</span>
          </button>
        </form>
      </div>
    ) : (
      <></>
    )
)
